import React, { useEffect, useState } from "react";
import { SessionVerification } from "../../../Components/SessionManagement/SessionManagement";
import CustHeader from '../../../Components/header/Header/CustHeader'
import CustomerSideBar from "../../../Components/sidebar/CustomerSideBar";
import QRCodeCanvas from 'qrcode.react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import NavigateNextOutlinedIcon from '@mui/icons-material/NavigateNextOutlined';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import {
    Box,
    Card,
    CardContent,
    CardMedia,
    Stack,
    Typography,
    Button,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useNavigate } from "react-router-dom";
import { addItem, removeItem } from '../../../redux/reducers/Cart'
import Carousel from 'react-material-ui-carousel'
import { Border } from "react-bootstrap-icons";
import AlertDialog from "../../../Components/AlertDialog/AlertDialog";


const ProductDetails = () => {
    //#region code
    const { currency } = useSelector((state) => state.GlobalVariables);
    const open = useSelector((state) => state.sideExpand.open);
    const navigate = useNavigate();
    const location = useLocation();
    const [images, setImages] = useState([]);
    const [itemDetails, setItemDetails] = useState('');
    const dispatch = useDispatch()
    const cartValue = useSelector((state) => state.cart.cartValue)
    const [isInCart, setIsInCart] = useState(false)
    const [formData, setFormData] = useState({})
    const [qrCode, setQrCode] = useState('');
    const [image, setImage] = useState(
        `https://dummyimage.com/400x400/7e8eff/ffffff&text=Product+Image`
    )
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogContent, setDialogContent] = useState('');

    const handleOpenDialog = (content) => {
        setDialogContent(content);
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
        setDialogContent('');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((state) => ({
            ...state,
            [name]: value
        }));
        if (name === 'size_id') {
            const selectedSize = itemDetails.size.filter((item) => (value === item.id));
            setFormData((state) => ({
                ...state,
                item_size: selectedSize[0].size
            }));
        }
    }

    useEffect(() => {
        const proImg = location.state.image;
        const proData = location.state.data;
        setImages(proImg);
        setItemDetails(proData);
        const qrCodeData = `http://demo.d-crm.in/product-info?itemId=${proData.id}&uuid=${proData.qr_code}`
        setQrCode(qrCodeData);
    }, []);

    useEffect(() => {
        isItemInCart()
    }, [cartValue]);

    // const fetchItemSize = async () => {
    //     try {
    //         const result = await configServ.getItemSize({ "item_id": data.id })
    //         const filtered = result.filter((item) => {
    //             return item.size !== 'Primary'
    //         })
    //         // console.log(filtered)
    //         setItemSize(filtered)
    //     } catch (err) {
    //         console.log(err)
    //     }
    // }

    const manageCart = () => {
        const dataToSend = {
            ...formData,
            id: itemDetails.id,
            company_id: itemDetails.company_id,
            itemname: itemDetails.item_name,
            hsn_code: itemDetails.hsncode,
            Taxrate: itemDetails.tax_rate,
            rate: itemDetails.rate_unit,
            item_code: itemDetails.item_code,
            issizeAdded: Boolean(itemDetails.issizeAdded),
        }
        if (!isInCart) {
            if (Boolean(itemDetails.issizeAdded)) {
                if (formData.item_size) {
                    dispatch(addItem(dataToSend))
                } else {
                    handleOpenDialog('Please select a size for the item')
                }
            } else {
                dispatch(addItem(dataToSend))
            }
        } else {
            dispatch(removeItem(itemDetails.id))
        }
    }

    const isItemInCart = () => {
        const inCart = cartValue.find((item) => {
            return item.id === location.state.data.id
            // console.log(item.id === location.state.data.id)
        })
        if (inCart !== undefined) {
            setIsInCart(true)
            return cartValue
        } else {
            setIsInCart(false)
            return cartValue
        }
    }
    //#endregion

    return (
        <>
            <AlertDialog
                open={dialogOpen}
                setOpen={handleCloseDialog}
                title="Alert"
                message={dialogContent}
                buttonTitle="Ok"
            />
            <SessionVerification />
            <CustHeader />
            <CustomerSideBar />
            <Box sx={{
                marginLeft: {
                    xs: 7,
                    sm: 8,
                },
                ...(open && { marginLeft: 33 }),
                transition: '200ms',
                minHeight: '77vh',
                backgroundColor: '#EEEEEE77',
            }}>
                <Stack
                    direction={{
                        xs: 'column',
                        md: 'row'
                    }}
                    minHeight='40vh'
                    mx={2}
                >
                    <Carousel
                        autoPlay infiniteLoop transitionTime={500} showThumbs={false}
                        sx={{
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flex: 2
                        }}
                        NextIcon={<NavigateNextOutlinedIcon />}
                        PrevIcon={<ArrowBackIosNewOutlinedIcon />}
                    >
                        {images.length === 0 ?
                            <>
                                <Card>
                                    <CardMedia
                                        component="img"
                                        alt='product'
                                        height='500px'
                                        image={image}
                                        style={{ objectFit: 'contain' }}
                                    />
                                </Card>
                            </> :
                            images.map((item) => (
                                <div key={item.id}>
                                    <Card>
                                        <CardMedia
                                            component="img"
                                            alt='product'
                                            height='500px'
                                            image={`data:image/png;base64,${item.image}`}
                                            style={{ objectFit: 'contain' }}
                                        />
                                    </Card>
                                </div>
                            ))}
                    </Carousel>

                    <Stack
                        sx={{
                            background: 'white',
                            flex: 1,
                            padding: 5
                        }}
                        spacing={1}
                    >
                        <Typography variant="h4"><b>{itemDetails.item_name}</b></Typography>
                        <Typography variant="h6" color='text.secondary'>Brand: {itemDetails.brand}</Typography>
                        <Typography variant="h6" color='text.secondary'>Category: {itemDetails.category}</Typography>
                        <Typography variant="body2" color='text.secondary'>{itemDetails.description}</Typography>
                        <Typography variant="h5" sx={{ color: '#0ab10a' }}>{currency} {itemDetails.rate_unit}</Typography>
                        {Boolean(itemDetails.issizeAdded) &&
                            <FormControl
                                fullWidth
                                size='small'
                                sx={{
                                    width: {
                                        md: '45%',
                                        xs: '100%'
                                    },
                                    // height: '1.7rem',
                                    fontSize: {
                                        xs: '0.35rem',
                                        sm: '0.45rem',
                                        md: '0.65rem'
                                    },
                                }}
                            >
                                <InputLabel >Size</InputLabel>
                                <Select
                                    label="Size"
                                    name='size_id'
                                    // sx={{
                                    //     height: '100%'
                                    // }}
                                    onChange={handleChange}
                                    value={formData.size_id || ''}
                                >
                                    {itemDetails.size.map((item) => {
                                        return (
                                            <MenuItem key={item.id} value={item.id}>{item.size}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        }
                        <Stack
                            direction={{
                                md: 'row',
                                xs: 'column'
                            }}
                            spacing={3}
                        >
                            <Button
                                onClick={manageCart}
                                variant={isInCart ? 'contained' : 'outlined'}
                                sx={{
                                    // width: '50%',
                                    minHeight: '2rem',
                                    flex: 1,
                                    ...(!isInCart && { backgroundColor: '#1976d211' }),
                                    ...(isInCart && { backgroundColor: '#333', ":hover": { backgroundColor: '#333333dd' } }),
                                    fontSize: { xs: '0.75rem', sm: '0.75rem', md: '0.65rem' }
                                }}
                            >
                                {isInCart ? 'Remove' : 'Add to Cart'}
                            </Button>
                            <Button
                                onClick={() => { navigate('/product') }}
                                variant='outlined'
                                sx={{
                                    color: '#333',
                                    borderColor: '#333',
                                    backgroundColor: '#33333311',
                                    // width: '50%',
                                    minHeight: '2rem',
                                    flex: 1,
                                    fontSize: {
                                        xs: '0.75rem',
                                        sm: '0.75rem',
                                        md: '0.65rem'
                                    }
                                }}
                            >
                                View All Products
                            </Button>
                        </Stack>
                        {
                            itemDetails.qr_code !== null && itemDetails.qr_code !== undefined &&
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <QRCodeCanvas value={qrCode} />
                                {/* <img
                                    alt='Not Found'
                                    src={itemDetails.qr_code}
                                    style={{ marginRight: 30 }}
                                    width={200}
                                /> */}
                            </div>
                        }
                    </Stack>
                </Stack>
            </Box>
            <br /><br />
        </>
    )
};
export default ProductDetails;